export const SEARCH_ANALYTICS_QUERY_MAX_LENGTH = 100;

export function normalizeSearchAnalyticsQuery(query: string): string {
  return query
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .slice(0, SEARCH_ANALYTICS_QUERY_MAX_LENGTH);
}

export function countSearchResults(
  type: 'all' | 'creators' | 'members' | 'people' | 'posts' | 'articles' | 'topics',
  counts: {
    creators: number;
    members: number;
    people: number;
    posts: number;
    articles?: number;
    topics: number;
  },
): number {
  if (type === 'all') {
    return counts.people + counts.posts + (counts.articles ?? 0) + counts.topics;
  }

  if (type === 'articles') {
    return counts.articles ?? 0;
  }

  return counts[type];
}
